'use client';
import React, { useRef } from 'react';

import { Text } from '~components/Typography';
import { useAuthActionsContext } from '~context/auth';
import { RegisterInbound } from '~features/annals/enums/register';
import annalsNavigation from '~features/annals/hooks/navigation';
import { useLanguage } from '~features/language';
import { useTranslations } from '~i18n/hooks';
import DotDotDotIcon from '~public/assets/icons/dotdotdot.svg';
import LoginIcon from '~public/assets/icons/navigation/login.svg';
import WebIcon from '~public/assets/icons/navigation/web.svg';
import { ButtonIconGhost } from '~shared/ui/atoms/Buttons/ButtonGhost/Icon';
import { ButtonPrimary } from '~shared/ui/atoms/Buttons/ButtonPrimary';
import {
	Dropdown,
	DropdownElement,
	DropdownSeparator,
} from '~shared/ui/atoms/Dropdown';
import { useHeaderContext } from '~widgets/Header/context';

export const NotAuthContent = () => {
	const { openRegister, openLogin } = useAuthActionsContext();
	const { languageOpen } = useHeaderContext();
	const { language, locale } = useLanguage();
	const t = useTranslations('ProfileMenu');
	const dropdownRef = useRef<HTMLButtonElement | null>(null);
	const annalsNavLoginClicked = annalsNavigation.useNavTopLoginButtonClicked();

	const handleRegister = () => {
		openRegister({
			analytics: { inbound: RegisterInbound.HeaderClickAction },
		});
	};

	const handleLogin = () => {
		annalsNavLoginClicked();
		openLogin({
			analytics: { inbound: RegisterInbound.LoginModalSwitchToCreate },
		});
	};

	return (
		<>
			<ButtonPrimary onClick={handleRegister} size="M">
				{t('signUp')}
			</ButtonPrimary>
			<ButtonIconGhost
				size="M"
				ref={dropdownRef}
				bigIcon={true}
				leftIcon={<DotDotDotIcon />}
			/>
			<Dropdown targetRef={dropdownRef}>
				<DropdownElement onClick={handleLogin} icon={<LoginIcon />}>
					<Text size="M" align="left">
						{t('logIn')}
					</Text>
				</DropdownElement>
				<DropdownSeparator />
				<DropdownElement
					data-name="language"
					icon={<WebIcon />}
					onClick={languageOpen}
					hint={`${language} - ${locale.toUpperCase()}`}
				>
					<Text size="M" align="left">
						{t('languageTitle')}
					</Text>
				</DropdownElement>
			</Dropdown>
		</>
	);
};
